import FormElement from '../components/FormElement';
import validate from 'validate.js';

export default class Step2Validator {
    constructor(validationFields) {

        this.createNipValidator();

        this.formFields = validationFields;

        this.constraints = this.createBasicConstraints();
        this.countryElement = $('#basketorder-customer-kraj-step2');

        this.currentCountry = 'PL';

        this.createUserFullNameValidator();
    }

    validateInvoice() {
        this.validateInvoice = true;
    }

    dontValidateInvoice() {
        this.validateInvoice = false;
    }

    setContry(countryShortName) {
        this.country = countryShortName;
    }

    createNipValidator() {
        validate.validators.nip = function(nip, options, key, attributes) {

            if(nip == null) {
                return null;
            }
            //Check digits
            for (let i=0; i<10; i++)
                if (isNaN(nip[i]))
                    return false;

            let sum = 6 * nip[0] +
                5 * nip[1] +
                7 * nip[2] +
                2 * nip[3] +
                3 * nip[4] +
                4 * nip[5] +
                5 * nip[6] +
                6 * nip[7] +
                7 * nip[8];
            sum %= 11;

            if (nip[9] != sum)
                return '^Zły format NIP';

            return null;
        };
    }

    createUserFullNameValidator() {
        validate.validators.fullName = function (fullName, options, key, attrbs) {

            if(fullName) {
                let result = fullName.split(' ');
                if(result.length != 2) {
                    return '^Proszę podać imię i nazwisko';
                }

                if(result[1].length == 0) {
                    return '^Proszę podać imię i nazwisko';
                }
            }
        }
    }

    createInvoiceConstraints() {
        return {
            'basketorder[invoice][f_nip]' : {
                presence: {
                    allowEmpty : false,
                },
                nip : true,
                length: {
                    is: 10,
                    message : '^Zła długośc.'
                }
            },
            'basketorder[invoice][f_nazwa]' : {
                presence: {
                    allowEmpty : false,
                }
            },
            'basketorder[invoice][numer]' : {
                presence: {
                    allowEmpty : false,
                }
            },
            'basketorder[invoice][f_adres]' : {
                presence: {
                    allowEmpty : false,
                }
            },
            'basketorder[invoice][f_kod_pocztowy]' : {
                presence: {
                    allowEmpty : false,
                }
            },
            'basketorder[invoice][f_miejscowosc]' : {
                presence: {
                    allowEmpty : false,
                }
            }
        }
    }

    createBasicConstraints() {
        return {
            'basketorder[customer][full_name]' : {
                presence: {
                    allowEmpty : false,
                },
                fullName : {
                    ok : true
                }
            },
            'basketorder[customer][adres]' : {
                presence: {
                    allowEmpty : false,
                }
            },
            'basketorder[customer][numer]' : {
                presence: {
                    allowEmpty : false,
                }
            },
            'basketorder[customer][kod_pocztowy]' : {
                presence: {
                    allowEmpty : false,
                }
            },
            'basketorder[customer][miejscowosc]' : {
                presence: {
                    allowEmpty : false,
                }
            },
            'basketorder[customer][telefon]' : {
                presence: {
                    allowEmpty : false,
                },
                length: {
                    minimum: 9,
                    maximum: 15,
                    message : '^Zła długośc.'
                }
            },
            'basketorder[customer][email]' : {
                presence: true,
                email: true
            }
        }
    }

    disableAddressValidation() {
        this.constraints = {
            'basketorder[customer][full_name]' : {
                presence: {
                    allowEmpty : false,
                },
                fullName : {
                    ok : true
                }
            },
            'basketorder[customer][telefon]' : {
                presence: {
                    allowEmpty : false,
                },
                length: {
                    minimum: 9,
                    maximum: 15,
                    message : '^Zła długośc.'
                }
            },
            'basketorder[customer][email]' : {
                presence: true,
                email: true
            }
        }
    }

    enableAddressValidation() {
        this.constraints = this.createBasicConstraints();
    }


    validateField(fieldData) {
        if(fieldData[0] === undefined) {
            return ;
        }

        if(fieldData[0].name === undefined) {
            return true;
        }

        let constraints = this.constraints;
        if(this.validateInvoice) {
            constraints = {...this.constraints, ... this.createInvoiceConstraints()};
        }

        let validationData = {};
        validationData[fieldData[0].name] = (fieldData[0].value ==  "" ? null: fieldData[0].value);

        let fieldValidation =  validate(validationData, constraints);



        return fieldValidation[[fieldData[0].name]];
    }

    validate(formData) {
        let validatorRef = this;

        var validationResult = true;

        this.formFields.each(function(index, field) {
            let result = validatorRef.validateField($(this).serializeArray());
            let fieldC = new FormElement($(this));
            let r = fieldC.onValidationResult(result);

            if(r === false) {
                validationResult = false;
            }
        });

        if($('#basketorder-create_account-1').prop('checked')) {

            $.ajax({
                url : '/user/',
                data : {
                    email : $('#basketorder-customer-email').val()
                },
                async: false
            }).success(function (response) {
                validationResult = response.status != 1 && validationResult;

                if(response.status == 1) {
                    alert('Podane konto zostało już zarejestrowane');
                }

            });
        }
        return validationResult;
    }
}
